let Funcs = {

    groupBy(array, key){
        // Return the end result
        return array.reduce((result, currentValue) => {
            // If an array already present for key, push it to the array. Else create an array and push the object
            (result[currentValue[key]] = result[currentValue[key]] || []).push(
                currentValue
            );
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            return result;
        }, {}); // empty object is the initial value for result object
    },

    getPlayerFullName(nick,name){

        if(name===""){
            return nick;
        } else {

            let fname=name.split(" ");
            return fname[0] + ' <span style="font-weight: bold;">"' + nick + '"</span> ' + fname[fname.length-1];

        }

    },

    formatDate(date,hours=false,year=false){
        let d= new Date(date);

        let months=['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

        let month=months[d.getMonth()].substring(0,3);

        let string=d.getDate() + " " + month;

        if(year!==false){
            string+= " " + d.getFullYear();
        }

        if(hours!==false){
            string+= " / <span>" + this.getLeadingZeros(d.getHours()) + ":" + this.getLeadingZeros(d.getMinutes()) + "</span>";
        }

        return string;

    },

    getLeadingZeros(value){
        return (value<10?'0':'')+value;
    },

    getImageUrl(url){
        return process.env.VUE_APP_CDN+url;
    }

};

export default Funcs;

